import * as React from 'react';
import { useTripStore } from 'pages/tracking-v2/trip-details-page/hooks';
import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';
import { TripDeliveryStatusIconAndLabel } from 'pages/tracking-v2/shared-components'
import { cn } from 'lib/utils';
import { Formatter } from 'utils';

import { InfoColumn } from './components';

type Props = React.ComponentProps<typeof Card>

const DATE_FALLBACK = '__/__/____';

export const TripInfoBar = ({ className, children, ...props }: Props) => {
  const { trip } = useTripStore();

  const deadlineDate = React.useMemo(() => {
    return trip?.deadlineDate
      ? Formatter.dateFull(trip?.deadlineDate)
      : DATE_FALLBACK;
  }, [trip?.deadlineDate]);

  return (
    <Card {...props}>
      <CardContent className={'flex flex-row pt-6 items-start 2xl:items-center'}>
        <div className={cn(
          'grid grid-cols-2 lg:grid-cols-4 gap-4 w-full items-start',
          '2xl:flex 2xl:flex-row 2xl:gap-10 2xl:max-w-[1100px]',
        )}>
          {!trip && (
            <>
              {Array.from({ length: 7 }).map((_, index) => (
                <div key={index} className={'flex flex-col gap-1'}>
                  <Skeleton key={index} className={'w-[60px] h-[14px]'} />
                  <Skeleton key={index} className={'w-[90px] h-3'} />
                </div>
              ))}
            </>
          )}
          {!!trip && (
            <>
              <InfoColumn>
                <TripDeliveryStatusIconAndLabel invoices={trip.invoices} />
              </InfoColumn>
              <InfoColumn>
                <InfoColumn.Title>Motorista</InfoColumn.Title>
                <InfoColumn.Content>{trip?.driverName || '---'}</InfoColumn.Content>
              </InfoColumn>
              <InfoColumn>
                <InfoColumn.Title>Placa do veículo</InfoColumn.Title>
                <InfoColumn.Content>{trip?.vehiclePlate || '---'}</InfoColumn.Content>
              </InfoColumn>
              <InfoColumn>
                <InfoColumn.Title>Prazo</InfoColumn.Title>
                <InfoColumn.Content>{deadlineDate}</InfoColumn.Content>
              </InfoColumn>
              <InfoColumn>
                <InfoColumn.Title>Peso bruto</InfoColumn.Title>
                <InfoColumn.Content>{Formatter.weight(trip?.totalProductsGrossWeight)}</InfoColumn.Content>
              </InfoColumn>
              <InfoColumn>
                <InfoColumn.Title>Peso líquido</InfoColumn.Title>
                <InfoColumn.Content>{Formatter.weight(trip?.totalProductsNetWeight)}</InfoColumn.Content>
              </InfoColumn>
              <InfoColumn>
                <InfoColumn.Title>Valor</InfoColumn.Title>
                <InfoColumn.Content>{Formatter.currency(trip?.totalProductsValue)}</InfoColumn.Content>
              </InfoColumn>
            </>
          )}
        </div>
        <div className={'flex items-center gap-2 shrink-0 ml-auto'}>
          {children}
        </div>
      </CardContent>
    </Card>
  );
};